import React, { useState } from "react";
import "./styles.css";

const Merch = () => {
    return (
        <div className="merch-content">
            <span className="merch-title">
                MERCH <img className="merch-title-img" src="images/shirt.gif" />
            </span>
            <p className="merch-desc">COMING SOON</p>
        </div>
    )
}

export default Merch;